import { c as _c } from "react/compiler-runtime";
import type { ComponentProps } from 'react';
import { L10nContextProvider } from './components/l10n-provider';
import { MachineProvider } from './components/machine-provider';
import Router from './pages/router';
import type { IdvProps } from './types';
import { checkIsInIframe } from './utils';
import type { IdvMachineArgs } from './utils/state-machine';
import './config/initializers/load-polyfills';
type RouterProps = ComponentProps<typeof Router>;
type AppProps = IdvProps & RouterProps;
const Idv = t0 => {
  const $ = _c(19);
  let isInIframe;
  let l10n;
  let onIdentifyDone;
  let props;
  if ($[0] !== t0) {
    ({
      l10n,
      onIdentifyDone,
      isInIframe,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = isInIframe;
    $[2] = l10n;
    $[3] = onIdentifyDone;
    $[4] = props;
  } else {
    isInIframe = $[1];
    l10n = $[2];
    onIdentifyDone = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== isInIframe) {
    t1 = isInIframe === undefined ? checkIsInIframe() : isInIframe;
    $[5] = isInIframe;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const newIsInIframe = t1;
  let t2;
  if ($[7] !== newIsInIframe || $[8] !== props) {
    t2 = {
      ...props,
      isInIframe: newIsInIframe
    };
    $[7] = newIsInIframe;
    $[8] = props;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const args = t2;
  let t3;
  if ($[10] !== l10n || $[11] !== onIdentifyDone) {
    t3 = <Router l10n={l10n} onIdentifyDone={onIdentifyDone} />;
    $[10] = l10n;
    $[11] = onIdentifyDone;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== args || $[14] !== t3) {
    t4 = <MachineProvider args={args}>{t3}</MachineProvider>;
    $[13] = args;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== l10n || $[17] !== t4) {
    t5 = <L10nContextProvider l10n={l10n}>{t4}</L10nContextProvider>;
    $[16] = l10n;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};
export default Idv;